import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserAccessList } from "@/apis";

const fetchUserAccess = createAsyncThunk("user/fetchAccessList", async () => {
    const response = await fetchUserAccessList();
    return response?.data?.response ?? [];
});

export { fetchUserAccess };
